<template>
  <div>
    <div>
      平台发票
    </div>
    <div class="content">
      <div class="radopGroupDiv">
          <el-radio-group v-model="activeName"  @change="handleClick">
            <el-radio-button label="top" class="handleClick">开具发票</el-radio-button>
            <el-radio-button label="right" >开票记录</el-radio-button>
          </el-radio-group>
        </div>
      <!-- 开具发票 -->
      <div>
        <!-- 提示 -->
        <div class="tips">
        <div class="fontdiv">
          <i class="iconfont icon-xingzhuang valueamount"></i> 温馨提示
        </div> 
        <p class="textp"> 1. 您可以在钱款到账之日起30日内（含）向HAIZOL.COM申请开票，逾期原则上我们将不再受理您的发票申请；</p>
        <p class="textp"> 2. 请确认您填写的开票信息准确无误，如因信息填写有误造成所开发票无效，HAIZOL.COM原则上不会再次受理您的同笔发票申请。</p>
        
        </div>
        <!-- 列表 -->
        <div>
          <listTabel></listTabel>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import listTabel from '@/components/invoice/listTabel.vue'
  export default {
    components: {
      listTabel,
    },
    data() {
      return {
        activeName: 'top'
      };
    },
    methods: {
      handleClick() {
        this.$router.push({
          name: "const-center-invoice-record"
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
.content{
  padding: 20px;
  background: #FFFFFF;
  margin-top: 10px;

}
::v-deep .radopGroupDiv{
  border-bottom: 1px solid #E5E8ED;
  .handleClick {
    .el-radio-button__orig-radio:checked + .el-radio-button__inner{
      background: #066eb71a !important;
      border: 1px solid #066EB7;
      color: #066EB7;
    }
  }
}
.tips{
  margin-top: 20px;
  background: #F5F7FA;
  padding: 24px 31px;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 14px;
  color: #4F5D78;
}
.valueamount{
  color: #FF7F2A;
}
.fontdiv{
  margin-bottom: 14px;
}
.icon-xingzhuang{
  font-size: 14px;
}
.textp{
  padding-left: 18px;
}
</style>